import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ElevationDialogComponent } from '../dialogs/elevation-dialog/elevation-dialog.component';
import { LocationUpdate } from '../dialogs/elevation-dialog/models/location-update.model';
import { MessageBoxDialogComponent } from '../dialogs/message-box-dialog/message-box-dialog.component';
import { IMessageBoxData } from '../dialogs/message-box-dialog/models/i-message-box-data.interface';
import { SideDialogService } from '../side-dialog/side-dialog.service';
import { LoadingGraphic } from './loading-graphic.controller';

@Injectable({
  providedIn: 'root',
})
export class EcapsCore {
  constructor(
    private dialog: MatDialog,
    private loadingGraphic: LoadingGraphic,
    private sideDialogService: SideDialogService
  ) {}

  public showMessageBox(
    data: IMessageBoxData,
    disableClose?: boolean
  ): Promise<any> {
    const promise = new Promise<boolean>((resolve) => {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.disableClose = !!disableClose;
      dialogConfig.autoFocus = true;
      dialogConfig.data = data;

      const dialogRef = this.dialog.open(
        MessageBoxDialogComponent,
        dialogConfig
      );

      const subscription = dialogRef.beforeClosed().subscribe((result) => {
        resolve(result);

        subscription.unsubscribe();
      });
    });

    return promise;
  }

  public showElevationDialog(): Promise<LocationUpdate> {
    const promise = new Promise<LocationUpdate>((resolve, reject) => {
      const dialogRef = this.sideDialogService.open<LocationUpdate>(
        ElevationDialogComponent,
        {
          disableClose: false,
          autoFocus: true,
          width: 1000,
        }
      );

      const subscription = dialogRef.closed.subscribe((results) => {
        resolve(results as LocationUpdate);

        subscription.unsubscribe();
      });
    });

    return promise;
  }

  public showLoadingGraphic(text: string, verifier: () => boolean) {
    this.loadingGraphic.show(text, verifier);
  }

  public hideLoadingGraphic(all: boolean = false) {
    this.loadingGraphic.hide(all);
  }
}
